import { ChatMessage, MessageUserType, TypingIndicator as TypingIndicatorLib } from '@missionlabs/smartagent-chat-components-lib';
import useApp from 'hooks/useApp';
import React, { useMemo } from 'react';

import { DEFAULT_LANGUAGE } from 'translations';

interface Props {
}

const BotTypingIndicator: React.FC<Props> = () => {

    const { agentLogoURL, logoURL, language, appTextTranslations } = useApp();

    const logo = logoURL ?? agentLogoURL;

    const translations = useMemo(() => {
        return {
            typingAriaLabel: appTextTranslations?.typingAriaLabel?.[language] ?? appTextTranslations?.typingAriaLabel?.[DEFAULT_LANGUAGE]!,
            chatbotAlt: appTextTranslations?.chatbotAlt?.[language] ?? appTextTranslations?.chatbotAlt?.[DEFAULT_LANGUAGE]!,
            newMessageNotificationText: appTextTranslations?.newMessageNotificationText?.[language] ?? appTextTranslations?.newMessageNotificationText?.[DEFAULT_LANGUAGE]!,
            starRatingAriaLabel: appTextTranslations?.starRatingAriaLabel?.[language] ?? appTextTranslations?.starRatingAriaLabel?.[DEFAULT_LANGUAGE]!,
            noRatingAriaLabel: appTextTranslations?.noRatingAriaLabel?.[language] ?? appTextTranslations?.noRatingAriaLabel?.[DEFAULT_LANGUAGE]!,
            starAriaLabel: appTextTranslations?.starAriaLabel?.[language] ?? appTextTranslations?.starAriaLabel?.[DEFAULT_LANGUAGE]!,
            starsAriaLabel: appTextTranslations?.starsAriaLabel?.[language] ?? appTextTranslations?.starsAriaLabel?.[DEFAULT_LANGUAGE]!,
            quickRepliesAriaLabel: appTextTranslations?.quickRepliesAriaLabel?.[language] ?? appTextTranslations?.quickRepliesAriaLabel?.[DEFAULT_LANGUAGE]!,
            statusLabels: {
                read: appTextTranslations?.statusLabels?.read?.[language] ?? appTextTranslations?.statusLabels?.read?.[DEFAULT_LANGUAGE]!,
                delivered: appTextTranslations?.statusLabels?.delivered?.[language] ?? appTextTranslations?.statusLabels?.delivered?.[DEFAULT_LANGUAGE]!,
                sent: appTextTranslations?.statusLabels?.sent?.[language] ?? appTextTranslations?.statusLabels?.sent?.[DEFAULT_LANGUAGE]!,
            },
            readAtAriaLabel: appTextTranslations?.readAtAriaLabel?.[language] ?? appTextTranslations?.readAtAriaLabel?.[DEFAULT_LANGUAGE]!,
            hideText: appTextTranslations?.hideText?.[language] ?? appTextTranslations?.hideText?.[DEFAULT_LANGUAGE]!,
            seeText: appTextTranslations?.seeText?.[language] ?? appTextTranslations?.seeText?.[DEFAULT_LANGUAGE]!,
            messageText: appTextTranslations?.messageText?.[language] ?? appTextTranslations?.messageText?.[DEFAULT_LANGUAGE]!,
            downloadLabel: appTextTranslations?.downloadLabel?.[language] ?? appTextTranslations?.downloadLabel?.[DEFAULT_LANGUAGE]!,
            receivedAtText: appTextTranslations?.receivedAtText?.[language] ?? appTextTranslations?.receivedAtText?.[DEFAULT_LANGUAGE]!,
            sentAtText: appTextTranslations?.sentAtText?.[language] ?? appTextTranslations?.sentAtText?.[DEFAULT_LANGUAGE]!,
            says: appTextTranslations?.says?.[language] ?? appTextTranslations?.says?.[DEFAULT_LANGUAGE]!,
            getSelectXOptionsFromY: appTextTranslations?.getSelectXOptionsFromY?.[language] ?? appTextTranslations?.getSelectXOptionsFromY?.[DEFAULT_LANGUAGE]!,
            cancel: appTextTranslations?.cancel?.[language] ?? appTextTranslations?.cancel?.[DEFAULT_LANGUAGE]!,
            submit: appTextTranslations?.submit?.[language] ?? appTextTranslations?.submit?.[DEFAULT_LANGUAGE]!,
        }
    }, [language, appTextTranslations]);

    return (
        <ChatMessage
            senderType={MessageUserType.AGENT}
            clientType={MessageUserType.AGENT}
            time=''
            sendMessage={() => { }}
            translations={translations}
        >
            <TypingIndicatorLib translations={{
                typingAriaLabel: translations.typingAriaLabel,
            }} senderType={MessageUserType.AGENT} companyLogoUrl={logo} />

        </ChatMessage>
    )
}

export default BotTypingIndicator;